export default __webpack_public_path__ + "static/media/slider3.c799fd2d.jpg";